import analytics from '../analytics'

export function sendMessage (apiClient, userId, emailAddress, fullName, serviceYear, address, selected, notes, message) {
  const pathTemplate = '/message'
  const method = 'POST'
  const params = {}
  const additionalParams = {}
  let body = {
    userId,
    emailAddress,
    fullName,
    serviceYear,
    address,
    selected,
    notes
  }

  if (message) body.message = message

  console.log('Calling %s on %s', method, pathTemplate)
  var start = analytics.currentTime()
  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
    .then((result) => {
      var end = analytics.currentTime()
      analytics.time('API', 'send-message', end - start, 'success')
      return result.data
    })
    .catch((error) => {
      var end = analytics.currentTime()
      analytics.time('API', 'send-message', end - start, 'error')
      console.log('Error sending message %j', error)
      throw error
    })
}



// WEBPACK FOOTER //
// ./src/api/message.js